var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DragDropContext, } from "@hello-pangea/dnd";
import { useCallback, useContext, useEffect } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { moveTaskRequest } from "../../../api/api";
import { StageModal } from "../../../components/Modal/StageModal/StageModal";
import { TaskModal } from "../../../components/Modal/TaskModal/TaskModal";
import { REFETCH_ACTIVE_PIPELINE_INTERVAL } from "../../../constants";
import { ActivePipelineContext } from "../../../providers/ActivePipelineContextProvider";
import { AddStage } from "./AddStage";
import { PipelineIntro } from "./PipelineIntro";
import { Stage } from "./Stage";
const Pipeline = () => {
    var _a, _b;
    const { state: { activePipeline }, dispatch, fetchAndSetPipelineData, } = useContext(ActivePipelineContext);
    useEffect(() => {
        const refetchDataInterval = setInterval(() => {
            if (activePipeline) {
                fetchAndSetPipelineData(activePipeline.id);
            }
        }, REFETCH_ACTIVE_PIPELINE_INTERVAL);
        return () => clearInterval(refetchDataInterval);
    }, [activePipeline]);
    const dispatchMove = (source, destination) => {
        if (source.droppableId === destination.droppableId) {
            dispatch({
                type: "REORDER_TASK",
                payload: {
                    source,
                    destination,
                },
            });
        }
        else {
            dispatch({
                type: "MOVE_TASK",
                payload: {
                    source,
                    destination,
                },
            });
        }
    };
    const onDragEnd = useCallback((result) => __awaiter(void 0, void 0, void 0, function* () {
        const { source, destination, draggableId } = result;
        if (!destination) {
            return;
        }
        dispatchMove(source, destination);
        try {
            yield moveTaskRequest(draggableId, destination.droppableId, destination.index);
        }
        catch (error) {
            console.error(error);
            dispatchMove(destination, source);
            toast.error(__("Failed to move a task", "quicktasker"));
        }
    }), [activePipeline]);
    const deleteTaskCallback = () => {
        if (activePipeline) {
            fetchAndSetPipelineData(activePipeline.id);
        }
    };
    if (!activePipeline) {
        return _jsx(PipelineIntro, {});
    }
    return (_jsxs("div", { className: "wpqt-pipeline-height wpqt-flex wpqt-gap-[24px] wpqt-overflow-x-auto wpqt-overflow-y-hidden", children: [_jsx(DragDropContext, { onDragEnd: onDragEnd, children: (_a = activePipeline.stages) === null || _a === void 0 ? void 0 : _a.map((stage) => {
                    return _jsx(Stage, { stage: stage }, stage.id);
                }) }), _jsx(AddStage, { pipelineId: activePipeline.id, stagesLength: (_b = activePipeline.stages) === null || _b === void 0 ? void 0 : _b.length }), _jsx(TaskModal, { deleteTaskCallback: deleteTaskCallback }), _jsx(StageModal, {})] }));
};
export default Pipeline;
